export const getNavigation = ({ isAdmin = false, isPlanner = false } = {}) => [
  { name: "Dashboard", href: "/dashboard", icon: "faHome" },
  { name: "Bridges", href: "/bridges", icon: "faBuilding" },
  {
    name: "Simulation Engine",
    href: "/enhanced-simulation-results",
    icon: "faChartLine",
  },
  { name: "Repair Projects", href: "/repair-projects", icon: "faWrench" },
  ...(!isPlanner
    ? [
        {
          name: "Masters Management",
          icon: "faClipboardList",
          children: [
            {
              name: "Corrosion & Damage",
              href: "/masters/corrosion-damage",
              icon: "faShieldAlt",
            },
            {
              name: "Simulation Triggers",
              href: "/masters/new-simulation-triggers",
              icon: "faPercent",
            },
            {
              name: "Cycle Limits",
              href: "/masters/maintenance-cycle-limits",
              icon: "faClock",
            },
            {
              name: "Surface Prep Methods",
              href: "/masters/surface-prep-methods",
              icon: "faWrench",
            },
            {
              name: "Washing Costs",
              href: "/masters/washing-costs",
              icon: "faSprayCan",
            },
            {
              name: "Wash Rules",
              href: "/masters/wash-rules",
              icon: "faSprayCan",
            },
            {
              name: "Paints Master",
              href: "/masters/materials-master",
              icon: "faCube",
            },
            {
              name: "Mobilization Costs",
              href: "/masters/mobilization-costs",
              icon: "faTruck",
            },
          ],
        },
      ]
    : []),
  ...(isAdmin
    ? [{ name: "User Management", href: "/users", icon: "faUsers" }]
    : []),
  { name: "Help & Documentation", href: "/help", icon: "faQuestionCircle" },
  ...(!isPlanner
    ? [{ name: "Settings", href: "/settings", icon: "faCog" }]
    : []),
];

export const flattenNavigationRoutes = (navigation) => {
  const routes = [];

  const visit = (items) => {
    items.forEach((item) => {
      if (item.href) {
        routes.push({ name: item.name, href: item.href });
      }
      if (Array.isArray(item.children) && item.children.length > 0) {
        visit(item.children);
      }
    });
  };

  visit(navigation || []);
  return routes;
};
